import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { cn } from "@/lib/utils";
import { flattenErrors } from "@/utils/formErrorUtils";
import { DatePicker } from "@/components/ui/DatePicker";
import { X } from "lucide-react";

/**
 * RHFDatePicker Component
 * A reusable DatePicker integrated with React Hook Form.
 */
const RHFDatePicker = ({
  name,
  label,
  className = "",
  buttonClassName = "",
  displayFormat = "dd-MM-yyyy",
  outputFormat = "yyyy-MM-dd",
  placeholder = "Pick a date",
  minDate,
  maxDate,
  disabled = false,
  required = false,
  isClear = false,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const flattened = flattenErrors(errors);

  return (
    <div className={className}>
      {/* Label */}
      {label && (
        <label className="block text-sm mb-1.5 text-text-secondary">
          {label} {required && <span className="text-red-500 font-bold text-[16px] ml-1">*</span>}
        </label>
      )}

      {/* Controller */}
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <div className="relative flex items-center">
            <DatePicker
              value={field.value}
              onChange={field.onChange}
              displayFormat={displayFormat}
              outputFormat={outputFormat}
              placeholder={placeholder}
              minDate={minDate}
              maxDate={maxDate}
              disabled={disabled}
              buttonClassName={cn(flattened[name] ? "border-red-500" : "border-border-primary", buttonClassName)}
            />

            {(field.value && isClear) && (
              <X
                className="absolute right-8 h-6 w-6 cursor-pointer text-text-secondary"
                onClick={() => field.onChange(null)}
              />
            )}
          </div>
        )}
      />

      {/* Error */}
      {flattened[name] && <p className="text-red-400 text-xs mt-1">{flattened[name]?.message}</p>}
    </div>
  );
};

export default RHFDatePicker;
